import {Widget} from "base/assets/js/widget/Widget.js";

export class LoadBar extends Widget {

	sClassStart = 'loadbar_start';
	sClassEnd = 'loadbar_end';

	start() {
		this._mod( '', this.sClassStart, true );
	}

	end() {
		this._mod( '', this.sClassEnd, true );
		setTimeout( () => {
			this._mod( '', this.sClassStart, false );
			this._mod( '', this.sClassEnd, false );
		}, 400 )
	}

}
